import { render } from "./withdraw-add.vue?vue&type=template&id=eddc661e&scoped=true"
import script from "./withdraw-add.vue?vue&type=script&lang=js"
export * from "./withdraw-add.vue?vue&type=script&lang=js"

import "./withdraw-add.vue?vue&type=style&index=0&id=eddc661e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddc661e"]])

export default __exports__